module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/regenerator/index.js
// module id = 236
// module chunks = 0 1